export default __webpack_public_path__ + "static/media/ambasadorp3big.9eec8e41.jpg";